<template>
  <base-button
    type="alternative"
    size="sm"
    class="tw:z-4 tw:-translate-x-1/2 tw:shadow-md"
    :icon="isSidebarVisible ? 'mdi-chevron-right' : 'mdi-chevron-left'"
    :tooltip="isSidebarVisible ? $i18n.t('sidebar.collapse') : $i18n.t('sidebar.expand')"
    @click="isSidebarVisible = !isSidebarVisible"
  />
</template>

<script>
import { sync } from 'vuex-pathify';

export default {
  name: 'HideSidebarButton',
  computed: {
    isSidebarVisible: sync('sidebar/isVisible'),
  },
};
</script>
